<template>
  <div ref="chartEl" class="echarts-view"></div>
</template>

<script>
export default {
  name: "EChartsView",
  props: {
    options: {
      type: Object,
      default: null,
    },
    onEvents: {
      type: Object,
      default: () => ({}),
    },
    autoresize: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      chart: null,
      boundEvents: {},
      resizeTimer: null,
    };
  },
  mounted() {
    this.initChart();
    if (this.autoresize) {
      window.addEventListener("resize", this.handleResize, { passive: true });
    }
  },
  beforeDestroy() {
    if (this.autoresize) {
      window.removeEventListener("resize", this.handleResize);
    }
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = null;
    }
    this.unbindEvents();
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  watch: {
    options: {
      deep: true,
      handler(newVal) {
        if (!this.chart || !newVal) return;
        this.chart.setOption(newVal, true);
      },
    },
    onEvents: {
      deep: true,
      handler() {
        this.bindEvents();
      },
    },
  },
  methods: {
    initChart() {
      if (!this.$echarts) return;
      this.chart = this.$echarts.init(this.$refs.chartEl);
      this.bindEvents();
      if (this.options) {
        this.chart.setOption(this.options, true);
      }
      this.$emit("ready", this.chart);
    },
    handleResize() {
      if (!this.chart) return;
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        if (this.chart) this.chart.resize();
      }, 100);
    },
    unbindEvents() {
      if (!this.chart) return;
      Object.entries(this.boundEvents || {}).forEach(([eventName, handler]) => {
        this.chart.off(eventName, handler);
      });
      this.boundEvents = {};
    },
    bindEvents() {
      if (!this.chart) return;
      this.unbindEvents();
      const events = this.onEvents || {};
      Object.keys(events).forEach((eventName) => {
        const fn = events[eventName];
        if (typeof fn !== "function") return;
        const handler = (params) => fn(params, this.chart);
        this.boundEvents[eventName] = handler;
        this.chart.on(eventName, handler);
      });
    },
    resize() {
      if (this.chart) this.chart.resize();
    },
  },
};
</script>

<style scoped>
.echarts-view {
  width: 100%;
  height: 100%;
}
</style>

